var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- ko if: _valid() --> <span class="summary-value"data-bind="template: { nodes: $componentTemplateNodes, data: $parent }"></span><!-- /ko --><!-- ko if: !_valid() --> <span class="summary-value bg-warning">Укажите недостающие данные</span> <!-- /ko -->';
}
return __p;
};
